<template>
  <section class="contact">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="py-4 px-6 font-bold text-xl flex text-talternative-color bg-balternative-color my-0">
          Contactformulier
        </h1>
        <v-contact-form @success="handleSuccessPopUp(true)" />
      </div>
    </div>
    <generic-modal v-if="showSuccessMessage" :has-close-button="true" @close="handleSuccessPopUp(false)">
      <template #header> Bericht verstuurd! </template>
      <template #body>
        <div>
          <p>
            Het contactformulier is verstuurd en wordt binnen 2 tot 5 werkdagen in behandeling genomen. Voor meer
            informatie kijk ook op onze
            <router-link to="/service#Question">
              <span @click="handleSuccessPopUp(false)">Veelgestelde vragen</span>.
            </router-link>
          </p>
        </div>
      </template>
      <template #footer>
        <v-button md primary @click="handleSuccessPopUp(false)"> Ok </v-button>
      </template>
    </generic-modal>
  </section>
</template>

<script>
import VContactForm from './ContactForm.vue';
import GenericModal from '@/components/shared/GenericModal';
import { ref } from 'vue';

export default {
  name: 'VPatienttransferbutton',
  components: {
    VContactForm,
    GenericModal
  },
  setup() {
    const showSuccessMessage = ref(false);

    const handleSuccessPopUp = (state = true) => {
      showSuccessMessage.value = state;
    };

    return {
      showSuccessMessage,
      handleSuccessPopUp
    };
  }
};
</script>
